import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    IconButton,
    Stack,
    TextField,
    Tooltip,
} from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import SendIcon from '@mui/icons-material/Send';
import ApiService from "../../services/categoryManagementApi";
import errorHandler from "../../utils/errorHandler";
import CustomLoader from "../../components/customLoader";
import SendNotification from "./SendNotification";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NotificationView from "./View";
import { capitalizeFirstLetter } from "../../utils/helpers";
const { NotificatiopnApi } = ApiService;


const TemplateList = ({notifications}) => {

    const navigate = useNavigate()
    const [sendNotificationData, setSendNotificationData] = useState({
        open: false,
        id: "",
        status: 1,
        mode: "",
    })
    const [paginData, setPaginData] = useState({
        totalCount: 0,
        data: []
    })
    const [loading, setLoading] = useState(true)
    const [pageSize, setPageSize] = useState(5)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchItem, setSearchItem] = useState("")


    const fetchtAllNotifications = async () => {
        try {
            setLoading(true)
            let data = {
                pageSize: pageSize,
                pageNumber: currentPage,
                searchItem: searchItem,
            }
            let res = await NotificatiopnApi.getAllNotificationTemplate(data)
            setPaginData({
                data: res?.data?.data?.result,
                totalCount: res?.data?.data?.totalRecords
            })
        } catch (error) {
            errorHandler(error)
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchtAllNotifications()
    }, [searchItem, pageSize, currentPage])

    const column = [
        {
            name: "S.No.",
            sortable: false,
            cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
          },
        {
            name: "Notification Type",
            selector: (row) => capitalizeFirstLetter(row?.notificationType),

        },
        {
            name: "Title",
            selector: (row) => row?.title,

        },
        // {
        //     name: "Status",
        //     cell: (row) => <SwitchButton status={row.status} id={row?._id} api={`notificationTemplate/changeStatus`} refresh={() => fetchtAllNotifications()} />
        // },
        {
            name: (
                <div >Action</div>
            ),
            cell: (row) => (
                <>
                    <Tooltip title="View" placement="top">
                        <IconButton
                            color="primary"
                            onClick={() => {
                                setSendNotificationData({
                                    open: true,
                                    id: row?._id,
                                    status: row.status,
                                    mode: "view"
                                })
                            }}
                        >
                           <VisibilityIcon />
                        </IconButton>
                    </Tooltip>
                    {/* <ViewModal
                        id={row?._id}
                        url={`notificationTemplate/getOneTemplate/${row?._id}`}
                        pageHeading="View Notification"
                        showField={[
                            { name: "Notification Type", type: "text", keyName: "notificationType" },
                            { name: "Title", type: "text", keyName: "title" },
                            { name: "Content", type: "text", keyName: "content" },

                        ]}
                    /> */}
                    <Tooltip title="Edit" placement="top">
                        <IconButton
                            color="primary"
                            onClick={() => {
                                navigate(`/notification-management/edit/${row?._id}`);
                            }}
                        >
                            <EditOutlined />
                        </IconButton>
                    </Tooltip>
                    {row.status == 1 ?
                        <Tooltip title="Send Notification" placement="top">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    setSendNotificationData({
                                        open: true,
                                        id: row?._id,
                                        status: row.status,
                                        mode: "send"
                                    })
                                }}
                            >
                                <SendIcon />
                            </IconButton>
                        </Tooltip>
                        :
                        <Tooltip title="Notification status is inactive" placement="top">
                            <IconButton>
                                <SendIcon />
                            </IconButton>
                        </Tooltip>
                    }

                </>
            ),
        },
    ]

    return (
        <>
            <Card style={{ marginTop: "15px"}}>
                <CardHeader
                    title="Notification Template"
                ></CardHeader>
                <Stack
                    direction={"row"}
                    spacing={1}
                    style={{ marginRight: "15px" }}
                    alignItems={{ xs: "flex-end", sm: "center" }}
                    justifyContent={"flex-end"}
                >
                    {/* <Stack direction={"row"} alignItems={"center"}>


                        <SearchBtn searchItem={searchItem} setSearchItem={setSearchItem} />

                    </Stack> */}



                    <Button
                        size="large"
                        type="submit"
                        variant="contained"
                        sx={{ ml: 3, mr: 3 }}
                        onClick={() => {
                            navigate("/notification-management/add")
                        }}
                    >
                        Add
                    </Button>
                </Stack>

                <CardContent>
                    <DataTable
                        customStyles={{
                            headCells: {
                              style: {
                                fontSize: "15px",
                                fontWeight: "bold",
                              },
                            },
                          }}
                        columns={column}
                        data={paginData?.data}
                        pagination
                        paginationServer
                        style={{ padding: "16px" }}
                        paginationTotalRows={paginData?.totalCount}
                        paginationPerPage={pageSize}
                        onChangePage={(page) => setCurrentPage(page)}
                        paginationRowsPerPageOptions={[5, 10, 20, 50]}
                        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                            setPageSize(currentRowsPerPage);
                            setCurrentPage(currentPage);
                        }}
                        persistTableHead={true}
                        progressPending={loading}
                        progressComponent={<CustomLoader />}
                    />
                </CardContent>

            </Card>
            {sendNotificationData.mode === "send" && (
                <SendNotification data={sendNotificationData} setData={setSendNotificationData} notifications={notifications} />
            )}
            {sendNotificationData.mode === "view" && (
                <NotificationView data={sendNotificationData} setData={setSendNotificationData} />
            )}

        </>
    )
}

export default TemplateList